import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { homeFaqs } from '../../data/faqs';
import { SITE } from '../../data/site';
import { Accordion } from '../ui/Accordion';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
export function FaqPreview() {
  return <section className="gutter section bg-mist" aria-labelledby="faq-preview-title" data-id="element-149" data-mp="12hl2bgir25hd">
      <div className="grid gap-12 lg:grid-cols-12" data-id="element-150" data-mp="204jsd8exsf6a">
        <div className="lg:col-span-4" data-id="element-151" data-mp="206d2ixordhj1">
          <SectionHeading id="faq-preview-title" title="Questions, Answered" intro="Still unsure? Call us — a real instructor picks up." data-id="element-152" data-mp="1v4xdkujgmqvd" />
          <div className="mt-8 flex flex-wrap gap-3" data-id="element-153" data-mp="1qcnrxqpdocyw">
            <ButtonLink href={SITE.phoneHref} variant="dark" data-id="element-154" data-mp="1lfxdt8x4vrg4">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="1ldjjx3e6wla5" /> {SITE.phoneDisplay}
            </ButtonLink>
            <ButtonLink to="/faq" variant="outline-dark" data-id="element-156" data-mp="2e41l1yvcsckx">
              All FAQs
            </ButtonLink>
          </div>
        </div>
        <div className="lg:col-span-8" data-id="element-157" data-mp="3995p3tdfz0v3">
          <Accordion items={homeFaqs} defaultOpen={0} data-id="element-158" data-mp="39a79iogckzph" />
        </div>
      </div>
    </section>;
}